/**
 * Tooltip Component
 *
 * A simple tooltip that shows on hover with help text.
 */

import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import { HelpCircle } from 'lucide-react';
import './Tooltip.css';

interface TooltipProps {
  content: string;
  children?: React.ReactNode;
  position?: 'top' | 'bottom' | 'left' | 'right';
}

export const Tooltip: React.FC<TooltipProps> = ({
  content,
  children,
  position = 'top',
}) => {
  const { t } = useTranslation('common');
  const [isVisible, setIsVisible] = useState(false);

  return (
    <span
      className="tooltip-wrapper"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
      onFocus={() => setIsVisible(true)}
      onBlur={() => setIsVisible(false)}
    >
      {children || (
        <button type="button" className="tooltip-trigger" aria-label={t('help')}>
          <HelpCircle size={16} />
        </button>
      )}
      {isVisible && (
        <span className={`tooltip-content tooltip-${position}`} role="tooltip">
          {content}
        </span>
      )}
    </span>
  );
};

export default Tooltip;
